export enum DataTypeGroupEnum {
  BOOLEAN = "BOOLEAN",
  STRING = "STRING",
  INTEGER = "INTEGER",
  FLOAT = "REAL"
}
